"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
const props = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,
  /** The markup node to insert into the button. */
  children: _propTypes.default.node,
  /** The type of button that is rendered. */
  type: _propTypes.default.oneOf(['button', 'submit', 'reset']),
  /** The color of the button. */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  /** If an icon is provided, whether to add the margin to the icon on the left or right side. */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /** Whether the button should display as a block level element. */
  block: _propTypes.default.bool,
  /** Whether the button is disabled or not. */
  disabled: _propTypes.default.bool,
  /** Whether to show a loading animation inside of the button. */
  loading: _propTypes.default.bool,
  /**
   * The handler to execute when the button is clicked.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onClick: _propTypes.default.func,
  /** Determines if the underlying HTML element should be an <a> or <button>. */
  asAnchor: _propTypes.default.bool
};
var _default = exports.default = props;